"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFactDisplaySideFactsProperty = exports.factDisplaySideFactsPropertyDefinition = void 0;
exports.factDisplaySideFactsPropertyDefinition = {
    view: {
        label: 'Display as Sidefact',
        style: 'toggle',
    },
    constraints: [],
    type: 'boolean',
    default: true,
    multiple: false,
    name: 'fact-display-sidefact',
};
const isFactDisplaySideFactsProperty = (prop) => {
    return prop.name === exports.factDisplaySideFactsPropertyDefinition.name;
};
exports.isFactDisplaySideFactsProperty = isFactDisplaySideFactsProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZmFjdC1kaXNwbGF5LXNpZGVmYWN0LnByb3BlcnR5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Byb3BlcnRpZXMvZmFjdC1kaXNwbGF5LXNpZGVmYWN0LnByb3BlcnR5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVhLFFBQUEsc0NBQXNDLEdBQUc7SUFDcEQsSUFBSSxFQUFFO1FBQ0osS0FBSyxFQUFFLHFCQUFxQjtRQUM1QixLQUFLLEVBQUUsUUFBUTtLQUNoQjtJQUNELFdBQVcsRUFBRSxFQUFFO0lBQ2YsSUFBSSxFQUFFLFNBQVM7SUFDZixPQUFPLEVBQUUsSUFBSTtJQUNiLFFBQVEsRUFBRSxLQUFLO0lBQ2YsSUFBSSxFQUFFLHVCQUF1QjtDQUNFLENBQUE7QUFJMUIsTUFBTSw4QkFBOEIsR0FBRyxDQUFDLElBQWtCLEVBQXdDLEVBQUU7SUFDekcsT0FBTyxJQUFJLENBQUMsSUFBSSxLQUFLLDhDQUFzQyxDQUFDLElBQUksQ0FBQTtBQUNsRSxDQUFDLENBQUE7QUFGWSxRQUFBLDhCQUE4QixrQ0FFMUMifQ==